<h1 mat-dialog-title>บันทึกบิล</h1>
<div mat-dialog-content>
    <mat-form-field class="center-table" appearance="fill">
        <input matInput [(ngModel)]="data.name" autofocus>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">ไม่บันทึก</button>
    <button mat-button [mat-dialog-close]="data.name">บันทึก</button>
</div>